export enum VarianceType {
   Actual_vs_Bid = "ACTUAL_BID",
   Actual_vs_Target = "ACTUAL_TARGET",
   Actual_vs_Forecast = "ACTUAL_FORECAST",
}

export enum PMReportType {
    Project_Status_Report_Summary = "PSR_SUMMARY",
    Project_Status_Report_Labor_Detail = "PSR_LABOR_DETAIL",
    Project_Status_Report_Expense_Detail = "PSR_EXPENSE_DETAIL",
    Resource_Utiliztion_Summary = "RESOURCE_UTILIZATION_SUMMARY"
}
